// extracted by mini-css-extract-plugin
export default {"errorContainer":"errorContainer_Qh7UHiTm","bold":"bold_IdAmgUzq","errorButton":"errorButton_7RW2NfoP"};